// variant-auto-select.js
(function() {
  // デバッグモード: true にするとコンソールにログ出力
  const DEBUG = false;

  function log(...args) {
    if (DEBUG) {
      console.log('[VariantAutoSelect]', ...args);
    }
  }

  function logGroup(title) {
    if (DEBUG) {
      console.group(`[VariantAutoSelect] ${title}`);
    }
  }

  function logGroupEnd() {
    if (DEBUG) {
      console.groupEnd();
    }
  }

  function logTable(data) {
    if (DEBUG) {
      console.table(data);
    }
  }

  // バリアント変更イベントを監視
  document.addEventListener('variant:change', (event) => {
    logGroup('variant:change イベント発火');
    log('イベント詳細:', event.detail);
    log('event.target:', event.target);
    log('event.target.tagName:', event.target?.tagName);
    log('event.target.id:', event.target?.id);
    
    // 方法1: event.target から探す
    let picker = event.target.closest('variant-picker');
    
    // 方法2: event.target が form の場合、form-id から探す
    if (!picker && event.target.tagName === 'FORM') {
      log('event.target は FORM 要素です');
      picker = document.querySelector(`variant-picker[form-id="${event.target.id}"]`);
      log('form-id から検索:', picker);
    }
    
    // 方法3: event.detail.formId から探す
    if (!picker && event.detail?.formId) {
      const formId = typeof event.detail.formId === 'string' 
        ? event.detail.formId 
        : event.detail.formId?.id;
      log('event.detail.formId:', formId);
      picker = document.querySelector(`variant-picker[form-id="${formId}"]`);
      log('detail.formId から検索:', picker);
    }

    // 方法4: ページ内の variant-picker を直接取得
    if (!picker) {
      picker = document.querySelector('variant-picker');
      log('ページ内から直接検索:', picker);
    }

    if (!picker) {
      log('❌ variant-picker が見つかりません');
      log('ページ内の variant-picker 要素:', document.querySelectorAll('variant-picker'));
      logGroupEnd();
      return;
    }

    log('✓ variant-picker 発見:', picker);

    // DOM更新後に実行
    setTimeout(() => {
      autoSelectAvailable(picker);
      logGroupEnd();
    }, 100);
  });

  function autoSelectAvailable(picker) {
    logGroup('autoSelectAvailable 実行');

    const formId = picker.getAttribute('form-id');
    const form = document.forms[formId] || document.getElementById(formId);
    
    log('フォームID:', formId);
    log('フォーム要素:', form);

    if (!form) {
      log('⚠️ フォームが見つかりませんが、処理を続行します');
    }

    // 全オプショングループを取得（複数のセレクタを試行）
    let optionGroups = picker.querySelectorAll('.variant-picker__option-values');
    
    if (optionGroups.length === 0) {
      optionGroups = picker.querySelectorAll('fieldset.variant-picker__option');
      log('fieldset から検索');
    }
    
    if (optionGroups.length === 0) {
      optionGroups = picker.querySelectorAll('.popover__value-list');
      log('popover__value-list から検索');
    }

    log(`オプショングループ数: ${optionGroups.length}`);

    if (optionGroups.length === 0) {
      log('❌ オプショングループが見つかりません');
      log('picker の innerHTML:', picker.innerHTML.substring(0, 500));
      logGroupEnd();
      return;
    }

    optionGroups.forEach((group, groupIndex) => {
      logGroup(`オプショングループ ${groupIndex + 1}`);
      
      // 入力要素を様々なセレクタで検索
      let allInputs = Array.from(group.querySelectorAll('input[data-option-position]'));
      
      if (allInputs.length === 0) {
        allInputs = Array.from(group.querySelectorAll('input[type="radio"]'));
        log('input[type="radio"] で検索');
      }

      log(`入力要素数: ${allInputs.length}`);

      if (allInputs.length === 0) {
        log('❌ 入力要素が見つかりません');
        log('group の innerHTML:', group.innerHTML.substring(0, 300));
        logGroupEnd();
        return;
      }

      // 現在の状態をテーブル表示
      const inputStatus = allInputs.map((input, i) => {
        const label = document.querySelector(`label[for="${input.id}"]`) || input.nextElementSibling;
        return {
          index: i,
          id: input.id,
          value: input.value,
          checked: input.checked,
          disabled: input.disabled,
          hidden: input.hidden,
          unavailable: isUnavailable(input),
          labelClass: label?.className || 'ラベルなし',
          optionPosition: input.dataset?.optionPosition
        };
      });
      logTable(inputStatus);

      const currentInput = allInputs.find(i => i.checked);
      
      if (!currentInput) {
        log('⚠️ 現在選択されている値がありません');
        
        const available = allInputs.find(i => !isUnavailable(i) && !i.hidden);
        if (available) {
          log(`✅ 自動選択: ${available.value}`);
          available.checked = true;
          available.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          log('❌ 有効な選択肢がありません');
        }
      } else {
        log(`現在の選択: ${currentInput.value}`);
        
        const currentUnavailable = isUnavailable(currentInput);
        log(`現在の選択が無効か: ${currentUnavailable}`);

        if (currentUnavailable) {
          const available = allInputs.find(i => !isUnavailable(i) && !i.hidden);
          
          if (available) {
            log(`✅ 無効な選択を検出 → 自動選択: ${available.value}`);
            available.checked = true;
            available.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            log('❌ 有効な選択肢がありません');
          }
        } else {
          log('✓ 現在の選択は有効です');
        }
      }
      
      logGroupEnd();
    });

    logGroupEnd();
  }

  function isUnavailable(input) {
    const label = document.querySelector(`label[for="${input.id}"]`) || 
                  input.nextElementSibling;

    const checks = {
      'input.disabled': input.disabled,
      'input.hidden': input.hidden,
      'label.is-sold-out': label?.classList?.contains('is-sold-out'),
      'label.is-unavailable': label?.classList?.contains('is-unavailable'),
      'label.is-disabled': label?.classList?.contains('is-disabled'),
      'closest[hidden]': !!input.closest('[hidden]'),
      'data-available=false': input.dataset?.available === 'false',
    };

    const result = checks['input.disabled'] || 
                   checks['label.is-sold-out'] ||
                   checks['label.is-unavailable'] ||
                   checks['label.is-disabled'] ||
                   checks['closest[hidden]'] ||
                   checks['data-available=false'];

    return result;
  }

  // デバッグ用グローバル関数
  window.variantAutoSelectDebug = {
    checkStatus: function() {
      console.group('現在のバリアント状態');
      
      const pickers = document.querySelectorAll('variant-picker');
      console.log(`variant-picker 要素数: ${pickers.length}`);
      
      pickers.forEach((picker, pi) => {
        console.group(`variant-picker ${pi + 1}`);
        console.log('form-id:', picker.getAttribute('form-id'));
        console.log('handle:', picker.getAttribute('handle'));
        
        const groups = picker.querySelectorAll('.variant-picker__option-values, fieldset.variant-picker__option');
        groups.forEach((group, i) => {
          console.group(`オプション ${i + 1}`);
          
          const inputs = group.querySelectorAll('input[type="radio"], input[data-option-position]');
          const data = Array.from(inputs).map(input => {
            const label = document.querySelector(`label[for="${input.id}"]`) || input.nextElementSibling;
            return {
              value: input.value,
              checked: input.checked,
              disabled: input.disabled,
              unavailable: isUnavailable(input),
              labelClass: label?.className
            };
          });
          
          console.table(data);
          console.groupEnd();
        });
        
        console.groupEnd();
      });
      
      console.groupEnd();
    },

    runAutoSelect: function() {
      const picker = document.querySelector('variant-picker');
      if (picker) {
        autoSelectAvailable(picker);
      } else {
        console.log('variant-picker が見つかりません');
      }
    },

    // DOM構造を確認
    inspectDOM: function() {
      console.group('DOM構造の確認');
      
      const picker = document.querySelector('variant-picker');
      if (!picker) {
        console.log('variant-picker が見つかりません');
        console.groupEnd();
        return;
      }

      console.log('variant-picker:', picker);
      console.log('属性:', {
        'form-id': picker.getAttribute('form-id'),
        'section-id': picker.getAttribute('section-id'),
        'handle': picker.getAttribute('handle'),
        'context': picker.getAttribute('context')
      });

      console.log('子要素のクラス一覧:');
      picker.querySelectorAll('*').forEach(el => {
        if (el.className) {
          console.log(`  ${el.tagName}: ${el.className}`);
        }
      });

      console.groupEnd();
    }
  };

  log('✓ variant-auto-select.js 読み込み完了');
  log('デバッグコマンド:');
  log('  variantAutoSelectDebug.checkStatus() - 現在の状態確認');
  log('  variantAutoSelectDebug.runAutoSelect() - 手動実行');
  log('  variantAutoSelectDebug.inspectDOM() - DOM構造確認');

})();